<dx-load-panel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoader" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="messageLoader" height="10%" width="15%"></dx-load-panel>
<div class="row animated fadeIn" *ngIf="add || edit">
    <div class="col-md-12">
        <div class="card-box">
            <form [formGroup]="this.userService.userForm" (ngSubmit)="onSubmit()" autocomplete="off">
                <div class="form_title">
                    <h4><strong> <i class=" icon-user-follow"></i></strong>Información Personal</h4>
                    <p>Ingrese sus datos personales </p>
                </div>
                <div class="step">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label for="dirActivo">Tipo de Logueo<span class="text-danger">*</span></label>
                                <select class="form-control required" formControlName="esUsuarioActivo" (change)="tipoLogChange($event)" name="dirActivo" id="dirActivo">
                                    <option value="false">Contraseña Portal</option>
                                    <option value="true">Directorio Activo</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div *ngIf="isActive()" class="form-group">
                                <label for="domainUserName">Usuario Activo<span class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="domainUserName" formControlName="domainUserName" placeholder="Nombre de usuario activo">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.Nombre" | translate}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="nombres" formControlName="Nombre" placeholder="Escribe su nombre">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.PrimerApellido" | translate}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="Primer-apellido" formControlName="Apellido1" placeholder="Escribe tu primer apellido">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.SegundoApellido" | translate}}</label>
                                <input type="text" class="form-control" id="Segundo-apellido" formControlName="Apellido2" placeholder="Escribe tu segundo apellido">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.TipoDocumento" | translate}}<span class="text-danger">*</span></label>
                                <select class="form-control required" formControlName="IdTipoDocumento" id="Tipo-identificacion" placeholder="Selecciona el tipo de identificación">
                  <option value="">Selecciona el tipo de identificación</option>
                  <option *ngFor="let opc of listTypeDocument" [value]="opc.idAdmCategoria">{{opc.nombre}}</option>
                </select>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.NumeroDocumento" | translate}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="numero-identificacion" formControlName="NumeroDocumento" placeholder="Escribe tu número de identificación">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.CorreoElectronico" | translate}}<span
                    class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="correo" formControlName="CorreoElectronico" placeholder="Escribe tu correo electrónico como nombre de usuario">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.ConfirmarCorreo" | translate}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="confirmar-correo" formControlName="ConfirmarCorreoElectronico" placeholder="Confirma tu correo electrónico">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>Cargo<span class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="cargo" formControlName="Cargo" placeholder="Escribe tu cargo">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label>{{"usuarios.crearUsuario.Telefono" | translate}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control required" id="telefono-opcionL" formControlName="Telefono" placeholder="Escribe tu número de contacto">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <label for="ciudad">Ciudad</label>
                            <ng-select2 id="idAdmCiudad" class="form-control" formControlName="idAdmCiudad" [data]="listCitys" [width]="500" [options]="singleOptions">
                            </ng-select2>
                        </div>
                    </div>
                </div>
                <!--End step -->
                <div class="step">
                    <div class="form_title">
                        <h4><strong><i class="icon-login"></i></strong>Datos Acceso</h4>
                        <p>Escoja el Rol y la Empresa para acceder a la aplicación</p>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <label for="rol">Rol<span class="text-danger">*</span></label>
                            <p class="text-muted font-14">
                                Seleccione el Rol o los Roles que va a tener en la Aplicación
                            </p>
                            <ng-select2 id="rol" [data]="multiRoles" formControlName="roles" [options]="options" [width]="500">
                            </ng-select2>
                            <!-- <select class="select2 form-control select2-multiple" formArrayName="roles" multiple="multiple" multiple
                data-placeholder="Seleccione ...">
                <option [value]="item.idSegRol" *ngFor="let item of roles">{{item.nombre}}</option>
              </select> -->
                        </div>

                        <div class="col-md-6 col-sm-6">
                            <label>Empresa<span class="text-danger">*</span></label>
                            <p class="text-muted font-14">
                                Seleccione las Empresas que va a tener a cargo
                            </p>
                            <ng-select2 [data]="multiCompanys" formControlName="companys" [options]="options" [width]="500">
                            </ng-select2>
                            <!-- <select class="select2 form-control select2-multiple" formArrayName="companys" multiple="multiple"
                multiple data-placeholder="Seleccione ...">
                <option [value]="item.idAdmEmpresa" *ngFor="let item of companys">{{item.nombre}}</option>
              </select> -->
                        </div>
                        <div class="col-md-6 col-sm-6" style="padding-top: 10px;">
                            <label>contratista<span class="text-danger">*</span></label>
                            <p class="text-muted font-14">Seleccione los contratistas</p>
                            <ng-select2 [data]="listContratistas" formControlName="contratista" [options]="singleOptions" [width]="500" [disabled]="!isUsuarioPacContratista" [readOnly]="!isUsuarioPacContratista">
                                </ng-select2>
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!--End step -->
                <div class="form-group text-right m-b-0">
                    <button type="reset" (click)="cancel()" class="btn btn-light waves-effect m-l-5"> {{ "botones.Cancelar" |
              translate }}</button>
                    <button class="btn btn-custom waves-effect waves-light" type="submit" [disabled]="!this.userService.userForm.valid">{{
              "botones.Guardar" | translate }}</button>
                </div>
            </form>
        </div>
    </div>
</div>